import { Map } from 'immutable';
import { actionTypes } from '../../../../controller';

const {
	SET_PREVIEW_IMAGE,
} = actionTypes;
const initialState = Map({
	isVisible: false,
	currentImageId: '',
});

export default function previewImage(state = initialState, action) {
	switch (action.type) {
		case SET_PREVIEW_IMAGE:
			return state
				.set('isVisible', action.isVisible)
				.set('currentImageId', action.currentImageId);

		default:
			return state;
	}
}
